import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../authentication/auth.guard';
import { HAuthorizeGuard } from '../authentication/h-authorize.guard';
import { AdminGuard } from '../authentication/admin.guard';
import { OrganiserGuard } from '../authentication/organiser.guard';

export const admin: Routes = [
  {
    path: 'dashboard',
    // canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'products',
        pathMatch: 'full',
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./products/products.component').then((m) => m.ProductsComponent),
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'sales',
      //   loadComponent: () =>
      //     import('./sales/sales.component').then((m) => m.SalesComponent),
      //   canActivate: [AuthGuard],
      // },
      {
        path: 'products/:id/analytics',
        loadComponent: () =>
          import('./analytics/analytics.component').then((m) => m.AnalyticsComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'hrm',
        loadComponent: () =>
          import('./hrm/hrm.component').then((m) => m.HrmComponent),
      },
      {
        path: 'personal',
        loadComponent: () =>
          import('./personal/personal.component').then((m) => m.PersonalComponent),
      },
    ]
  },
  {
    path: `admin`,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'admin/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard1',
        loadComponent: () =>
          import('./products/products.component').then((m) => m.ProductsComponent), data: { key: 'Dashboard', pageType: 'Operations & Management Reporting' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'leads',
        loadComponent: () =>
          import('./leads/leads.component').then((m) => m.LeadsComponent), data: { key: 'Leads', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'home-configuration',
        loadComponent: () =>
          import('./home-page/home-page.component').then((m) => m.HomePageComponent), data: { key: 'Homepage Configurations', pageType: 'Manage your homepage settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'ticket-upgrade',
        loadComponent: () => import('./ticket-upgrade/ticket-upgrade.component').then((m) => m.TicketUpgradeComponent),
        data: { key: 'Ticket Upgrade', pageType: 'Upgrade customer tickets to a different category' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'all-events',
        loadComponent: () =>
          import('./all-events/all-events.component').then((m) => m.AllEventsComponent), data: { key: 'All Events Configurations', pageType: 'Manage your all events configurations' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'cities-configuration',
        loadComponent: () =>
          import('./home-page/cities/cities.component').then((m) => m.CitiesComponent), data: { key: 'Homepage Configurations', pageType: 'Manage your homepage settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'categories-configuration',
        loadComponent: () =>
          import('./home-page/categeries/categeries.component').then((m) => m.CategeriesComponent), data: { key: 'Homepage Configurations', pageType: 'Manage your homepage settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns',
        loadComponent: () =>
          import('./campaigns/campaigns.component').then((m) => m.CampaignsComponent), data: { key: 'Campaigns Configurations', pageType: 'Manage your Campaigns settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
        {
        path: 'campaigns/email-dashboard',
        loadComponent: () =>
          import('./campaigns/email-dashboard/email-dashboard.component').then((m) => m.EmailDashboardComponent), data: { key: 'Campaigns Email Configurations', pageType: 'Manage your Campaigns Email settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/email',
        loadComponent: () =>
          import('./campaigns/campaigns.component').then((m) => m.CampaignsComponent), data: { key: 'Email Configurations', pageType: 'Manage your Email Campaigns settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/whatsapp',
        loadComponent: () =>
          import('./campaigns/campaigns.component').then((m) => m.CampaignsComponent), data: { key: 'Whatsapp Configurations', pageType: 'Manage your Whatsapp settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/whatsapp-dashboard',
        loadComponent: () =>
          import('./campaigns/whatsaap-dashboard/whatsaap-dashboard.component').then((m) => m.WhatsaapDashboardComponent), data: { key: 'Campaigns whatsapp Configurations', pageType: 'Manage your Campaigns whatsapp settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/whatsapp/templates',
        loadComponent: () =>
          import('./campaigns/whatsapp-template-list/whatsapp-template-list.component').then((m) => m.WhatsappTemplateListComponent), data: { key: 'Whatsapp Templates', pageType: 'Manage your WhatsApp templates' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/whatsapp/templates/:id',
        loadComponent: () =>
          import('./campaigns/whatsapp-template-create/whatsapp-template-create.component').then((m) => m.WhatsappTemplateCreateComponent), data: { key: 'Create WhatsApp Template', pageType: 'Create reusable WhatsApp message templates' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/whatsapp/settings',
        loadComponent: () =>
          import('./campaigns/whatsapp-settings/whatsapp-settings.component').then((m) => m.WhatsappSettingsComponent), data: { key: 'Whatsapp Settings', pageType: 'Connect and manage your WhatsApp Business API configuration' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/email-campaign',
        loadComponent: () =>
          import('./campaigns/email-campaign/email-campaign.component').then((m) => m.EmailCampaignComponent), data: { key: 'Campaigns Configurations', pageType: 'Manage your Campaigns settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/whatsapp-campaigns',
        loadComponent: () =>
          import('./campaigns/whatsapp-campaign/whatsapp-campaign.component').then((m) => m.WhatsappCampaignComponent), data: { key: 'Whatsapp Configurations', pageType: 'Manage your Whatsapp settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/whatsapp-campaigns/:id',
        loadComponent: () =>
          import('./campaigns/whatsapp-campaign-create/whatsapp-campaign-create.component').then((m) => m.WhatsappCampaignCreateComponent), data: { key: 'Whatsapp Configurations', pageType: 'Create your Whatsapp campaign' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/whatsapp-campaigns/flow/:id',
        loadComponent: () =>
          import('./campaigns/whatsapp-campaign-flow/whatsapp-campaign-flow.component').then((m) => m.WhatsappCampaignFlowComponent), data: { key: 'Whatsapp Campaign Flow', pageType: 'Track and review campaign flow details' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'campaigns/table-campaign',
        loadComponent: () =>
          import('./campaigns/campaign-table/campaign-table.component').then((m) => m.CampaignTableComponent), canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'campaigns/campaign-details/:id',
        loadComponent: () =>
          import('./campaigns/campaign-details/campaign-details.component').then((m) => m.CampaignDetailsComponent),
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'campaigns/domain-configuration',
        loadComponent: () =>
          import('./campaigns/domain-configuration/domain-configuration.component').then((m) => m.DomainConfigurationComponent),
        data: { key: 'Campaigns Configurations', pageType: 'Manage your Campaigns settings' },
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'campaigns/domain',
        loadComponent: () =>
          import('./campaigns/campaign-domains/campaign-domains.component').then((m) => m.CampaignDomainsComponent),
        data: { key: 'Campaigns Configurations', pageType: 'Manage your Campaigns settings' },
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'home-settings',
        loadComponent: () =>
          import('./website-settings/home-settings/home-settings.component').then((m) => m.HomeSettingsComponent),
        data: { key: 'Home settings', pageType: 'Manage your Home settings' },
        canActivate: [AuthGuard, AdminGuard]
      },
       {
        path: 'meta-tags/list',
        loadComponent: () =>
          import('./website-settings/meta-tags-list/meta-tags-list.component').then((m) => m.MetaTagsListComponent),
        data: { key: 'Meta Tags', pageType: 'Manage your Meta Tags' },
        canActivate: [AuthGuard, AdminGuard]
      },
       {
        path: 'website-content',
        loadComponent: () =>
          import('./website-settings/website-content/website-content.component').then((m) => m.WebsiteContentComponent),
        data: { key: 'Website Content', pageType: 'Manage your Website Content' },
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'our-sponsers',

        loadComponent: () =>
          import('./website-settings/our-sponsers/our-sponsers.component').then((m) => m.OurSponsersComponent),
        data: { key: 'Our Sponsors', pageType: 'Manage your Our Sponsors' },
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'our-partners',
        loadComponent: () =>
          import('./website-settings/our-partners/our-partners.component').then((m) => m.OurPartnersComponent),
        data: { key: 'Our Partners', pageType: 'Manage your Our Partners' },
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'meta-tags/create',
        loadComponent: () =>
          import('./website-settings/meta-tag-create/meta-tag-create.component').then((m) => m.MetaTagCreateComponent),
        data: { key: 'Meta Tags', pageType: 'Create your Meta Tags' },
        canActivate: [AuthGuard, AdminGuard]
      },
      
      {
        path: 'campaigns/tags',
        loadComponent: () =>
          import('./campaigns/campaign-tags/campaign-tags.component').then((m) => m.CampaignTagsComponent),
        data: { key: 'Tags', pageType: 'Manage your Tags settings' },
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'campaigns/segments',
        loadComponent: () =>
          import('./campaigns/campaign-segments/campaign-segments.component').then((m) => m.CampaignSegmentsComponent),
        data: { key: 'Segments', pageType: 'Manage your segments settings' },
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'genres-configuration',
        loadComponent: () =>
          import('./home-page/geners/geners.component').then((m) => m.GenersComponent), data: { key: 'Homepage Configurations', pageType: 'Manage your homepage settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'artist-configuration',
        loadComponent: () =>
          import('./home-page/artist/artist.component').then((m) => m.ArtistComponent), data: { key: 'Homepage Configurations', pageType: 'Manage your homepage settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'organisers',
        loadComponent: () =>
          import('./organisers/organisers.component').then((m) => m.OrganisersComponent), data: { key: 'Organisers', pageType: 'Manage Events & Listings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'organisers/organisers-details',
        loadComponent: () =>
          import('./organiser-details/organiser-details.component').then((m) => m.OrganiserDetailsComponent), data: { key: 'Organisers', pageType: 'Manage Events & Listings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'event',
        loadComponent: () =>
          import('./event/event.component').then((m) => m.EventComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'event/publish/:id',
        loadComponent: () =>
          import('./event/publish-event/publish-event.component').then((m) => m.PublishEventComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, AdminGuard],
      },
      // {
      //   path: 'users',
      //   loadComponent: () =>
      //     import('./users/users.component').then((m) => m.UsersComponent), data: { key: 'Users', pageType: 'Manage User Accounts' },
      //   canActivate: [AuthGuard, AdminGuard],
      // },
      {
        path: 'box-office/configuration',
        loadComponent: () =>
          import('./box-office/configuration-list/configuration-list.component').then((m) => m.ConfigurationListComponent), data: { key: 'Box Office', pageType: 'Manage Box Office Gates' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'box-office/configuration/:gateId',
        loadComponent: () =>
          import('./box-office/configuration/configuration.component').then((m) => m.ConfigurationComponent), data: { key: 'Box Office', pageType: 'Manage Box Office Tickets' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'box-office/scan-code',
        loadComponent: () =>
          import('./box-office/scan/scan.component').then((m) => m.ScanComponent), data: { key: 'Box Office', pageType: 'Manage Box Office Tickets' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'box-office/activity',
        loadComponent: () =>
          import('./box-office/activity/activity.component').then((m) => m.ActivityComponent), data: { key: 'Box Office', pageType: 'Manage Box Office Tickets' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'box-office/scan-details',
        loadComponent: () =>
          import('./box-office/scan-details/scan-details.component').then((m) => m.ScanDetailsComponent), data: { key: 'Box Office Scan Details ', pageType: 'Manage Box Office Scaning Details' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'box-office/issue-tickets',
        loadComponent: () =>
          import('./box-office/box-issue-tickets/box-issue-tickets.component').then((m) => m.BoxIssueTicketsComponent), data: { key: 'Box Office', pageType: 'Manage Box Office Tickets' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'issue-tickets',
        loadComponent: () =>
          import('../dashboard/issue-tickets/issue-tickets.component').then((m) => m.IssueTicketsComponent), data: { key: 'Issues Tickets', pageType: 'Manage Issues Tickets' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'bulk-upload',
        loadComponent: () =>
          import('./issue-tickets/bulk-issue-table/bulk-issue-table.component').then((m) => m.BulkIssueTableComponent), data: { key: 'Bulk Issues Tickets', pageType: 'Manage Bulk Issues Tickets' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'buyer',
        loadComponent: () =>
          import('./buyer/buyer.component').then((m) => m.BuyerComponent), data: { key: 'Buyer', pageType: 'Configure Buyer landing page' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'buyer/:id/buyer-details',
        loadComponent: () =>
          import('./buyer/view/view.component').then((m) => m.ViewComponent), data: { key: 'Buyer', pageType: 'Configure Buyer landing page' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'account',
        loadChildren: () =>
          import('../pages/account-management/account-management.module').then((m) => m.AccountManagementModule), // Lazy load AccountModule
        // canActivate: [AuthGuard],
      },
      {
        path: 'page-builder',
        loadComponent: () =>
          import('./page-builder/page-builder.component').then((m) => m.PageBuilderComponent), data: { key: 'Landing Page Builder', pageType: 'Configure your event landing page' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'create-event',
        loadComponent: () =>
          import('./event/create-event/create-event.component').then((m) => m.CreateEventComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'create-event/show/:id',
        loadComponent: () =>
          import('./event/event-shows/event-shows.component').then((m) => m.EventShowsComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'create-event/review/:id',
        loadComponent: () =>
          import('./event/event-review/event-review.component').then((m) => m.EventReviewComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'page-builder/list',
        loadComponent: () =>
          import('./page-builder/organiser-list/organiser-list.component').then((m) => m.OrganiserListComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, AdminGuard],
      },
       {
        path: 'customer-support/dashboard',
        loadComponent: () =>
          import('./customer-support/dashboard/dashboard.component').then((m) => m.DashboardComponent), data: { key: 'Customer Support Dashboard', pageType: 'Overview of all support activities and ticket status' },
        canActivate: [AuthGuard, AdminGuard],
      },
       {
        path: 'customer-support/issue-resolvers',
        loadComponent: () =>
          import('./customer-support/issue-resolvers/issue-resolvers.component').then((m) => m.IssueResolversComponent), data: { key: 'Customer Support Dashboard', pageType: 'Overview of all support activities and ticket status' },
        canActivate: [AuthGuard, AdminGuard],
      },
       {
        path: 'customer-support/support-tickets',
        loadComponent: () =>
          import('./customer-support/support-tickets/support-tickets.component').then((m) => m.SupportTicketsComponent), data: { key: 'Customer Support Dashboard', pageType: 'Overview of all support activities and ticket status' },
        canActivate: [AuthGuard, AdminGuard],
      },
       {
        path: 'users',
        loadComponent: () =>
          import('./organiser-user/organiser-user.component').then((m) => m.OrganiserUserComponent), data: { key: 'Organisers Audience', pageType: 'Organiser Audience' },
        canActivate: [AuthGuard, AdminGuard]
      },

      {
        path: 'dashboard',
        loadComponent: () =>
          import('./analytics/analytics.component').then(
            (m) => m.AnalyticsComponent
          ), data: { key: 'Dashboard', pageType: 'Operations & Management Reporting' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('../pages/profile/profile.component').then((m) => m.ProfileComponent),
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./settings/settings.component').then((m) => m.SettingsComponent), data: { key: 'Settings', pageType: 'Manage platform settings' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'settings/user-management',
        loadComponent: () =>
          import('./settings/settings.component').then((m) => m.SettingsComponent), data: { key: 'User Management', pageType: 'Manage users, roles and audit logs' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'settings/add-payment-gateway',
        loadComponent: () =>
          import('./settings/add-payment-gateway/add-payment-gateway.component').then((m) => m.AddPaymentGatewayComponent), data: { key: 'Add Payment Gateway', pageType: 'Add new payment gateway to the platform' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'settings/assign-payment-gateway',
        loadComponent: () =>
          import('./settings/assign-payment-gateway/assign-payment-gateway.component').then((m) => m.AssignPaymentGatewayComponent), data: { key: 'Assign Payment Gateway to Organiser', pageType: 'Assign payment gateways to organiser based on selection' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('./transactions/transactions.component').then((m) => m.TransactionsComponent), data: { key: 'Transactions', pageType: 'Manage  Transactions' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'devices-sessions/list',
        loadComponent: () =>
          import('./scanning-configuration/device-sessions/device-sessions.component').then((m) => m.DeviceSessionsComponent), data: { key: 'Device Sessions', pageType: 'Manage Device Sessions' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'operators',
        loadComponent: () =>
          import('./scanning-configuration/operator-table/operator-table.component').then((m) => m.OperatorTableComponent), data: { key: 'Operators', pageType: 'Manage Operators' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'supervisors-configuration',
        loadComponent: () =>
          import('./scanning-configuration/supervisor-table/supervisor-table.component').then((m) => m.SupervisorTableComponent), data: { key: 'Supervisors', pageType: 'Manage Supervisors' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'supervisors/:create',
        loadComponent: () =>
          import('./scanning-configuration/supervisors/supervisors.component').then((m) => m.SupervisorsComponent), data: { key: 'Supervisors', pageType: 'Manage Supervisors' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'supervisors/:id/operators',
        loadComponent: () =>
          import('./scanning-configuration/operators/operators.component').then((m) => m.OperatorsComponent), data: { key: 'operators', pageType: 'Manage Operators' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'supervisors/:supervisorId/operators/:operatorId',
        loadComponent: () =>
          import('./scanning-configuration/operator-details/operator-details.component').then((m) => m.OperatorDetailsComponent), data: { key: 'operators', pageType: 'Manage Operator Details' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'devices-configuration',
        loadComponent: () =>
          import('./scanning-configuration/devices/devices.component').then((m) => m.DevicesComponent), data: { key: 'Devices', pageType: 'Manage Devices' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'devices-configuration/:id',
        loadComponent: () =>
          import('./scanning-configuration/device-details/device-details.component').then((m) => m.DeviceDetailsComponent),
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'participants',
        loadComponent: () =>
          import('./participants/participants.component').then((m) => m.ParticipantsComponent), data: { key: 'Participants Audience', pageType: 'Participants Audience' },
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'transactions/:id/details',
        loadComponent: () =>
          import('./transactions/transactions-details/transactions-details.component').then((m) => m.TransactionsDetailsComponent),
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'registration/list',
        loadComponent: () =>
          import('./register/list/list.component').then((m) => m.ListComponent), data: { key: 'Registers', pageType: 'Configure Register page' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'notification/list',
        loadComponent: () =>
          import('./notification/notification-list/notification-list.component').then((m) => m.NotificationListComponent), data: { key: 'Notifications', pageType: 'Configure App Notifications' },
        canActivate: [AuthGuard, AdminGuard],
      },
       {
        path: 'notification/:create',
        loadComponent: () =>
          import('./notification/app-notification/app-notification.component').then((m) => m.AppNotificationComponent), data: { key: 'Notifications', pageType: 'Configure App Notifications' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'registration/details/:id',
        loadComponent: () =>
          import('./register/details/details.component').then((m) => m.DetailsComponent), data: { key: 'Register-details', pageType: 'Configure Register Details Page' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'promo-codes',
        loadComponent: () =>
          import('./discount-promocode/promo-code/promo-code.component').then((m) => m.PromoCodeComponent),
        data: { key: 'Discount & Promo Codes', pageType: 'Manage Discount & Promo Codes' },
        canActivate: [AuthGuard, AdminGuard],
      },
      {
        path: 'promo-codes/discount-rules',
        loadComponent: () =>
          import('./discount-promocode/discount-rule/discount-rule.component').then((m) => m.DiscountRuleComponent),
        data: { key: 'Discount Rule', pageType: 'Manage Discount & Promo Codes' },
        canActivate: [AuthGuard, AdminGuard],
      },
    ]
  },
  {
    path: `organiser`,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'organiser/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'ticket-upgrade',
        loadComponent: () => import('./ticket-upgrade/ticket-upgrade.component').then((m) => m.TicketUpgradeComponent),
        data: { key: 'Ticket Upgrade', pageType: 'Upgrade customer tickets to a different category' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'events',
        loadComponent: () =>
          import('./organiser-details/organiser-details.component').then((m) => m.OrganiserDetailsComponent), data: { key: 'Organisers Events', pageType: 'Manage Events & Listings' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./organiser-dashboard/organiser-dashboard.component').then((m) => m.OrganiserDashboardComponent), data: { key: 'Organisers Dashboard', pageType: 'Manage Organiser Events Data' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('../pages/profile/profile.component').then((m) => m.ProfileComponent), data: { key: 'Profile', pageType: 'Manage Information' },
        canActivate: [AuthGuard],
      },
      {
        path: 'event',
        loadComponent: () =>
          import('./event/event.component').then((m) => m.EventComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'issue-tickets',
        loadComponent: () =>
          import('../dashboard/issue-tickets/issue-tickets.component').then((m) => m.IssueTicketsComponent), data: { key: 'Issues Tickets', pageType: 'Manage Issues Tickets' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'box-office/configuration',
        loadComponent: () =>
          import('./box-office/configuration-list/configuration-list.component').then((m) => m.ConfigurationListComponent), data: { key: 'Box Office', pageType: 'Manage Box Office Gates' },
        canActivate: [AuthGuard, OrganiserGuard],
      },

       {
        path: 'box-office/configuration/:gateId',
        loadComponent: () =>
          import('./box-office/configuration/configuration.component').then((m) => m.ConfigurationComponent), data: { key: 'Box Office', pageType: 'Manage Box Office Tickets' },
        canActivate: [AuthGuard, OrganiserGuard],
      },

      {
        path: 'box-office/scan-details',
        loadComponent: () =>
          import('./box-office/scan-details/scan-details.component').then((m) => m.ScanDetailsComponent), data: { key: 'Box Office Scan Details ', pageType: 'Manage Box Office Scaning Details' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'notification/list',
        loadComponent: () =>
          import('./notification/notification-list/notification-list.component').then((m) => m.NotificationListComponent), data: { key: 'Notifications', pageType: 'Configure App Notifications' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
       {
        path: 'notification/:create',
        loadComponent: () =>
          import('./notification/app-notification/app-notification.component').then((m) => m.AppNotificationComponent), data: { key: 'Notifications', pageType: 'Configure App Notifications' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'bulk-upload',
        loadComponent: () =>
          import('./issue-tickets/bulk-issue-table/bulk-issue-table.component').then((m) => m.BulkIssueTableComponent), data: { key: 'View Issues Tickets', pageType: 'Manage View Issues Tickets' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
       {
        path: 'operators',
        loadComponent: () =>
          import('./scanning-configuration/operator-table/operator-table.component').then((m) => m.OperatorTableComponent), data: { key: 'View Issues Tickets', pageType: 'Manage View Issues Tickets' },
        canActivate: [OrganiserGuard],
      },
      {
        path: 'create-event',
        loadComponent: () =>
          import('./event/create-event/create-event.component').then((m) => m.CreateEventComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'create-event/show/:id',
        loadComponent: () =>
          import('./event/event-shows/event-shows.component').then((m) => m.EventShowsComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'organisers-details',
        loadComponent: () =>
          import('./organiser-details/organiser-details.component').then((m) => m.OrganiserDetailsComponent), data: { key: 'Events', pageType: 'Manage Events & Listings' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('./transactions/transactions.component').then((m) => m.TransactionsComponent), data: { key: 'Transactions', pageType: 'Manage  Transactions' },
      },
      {
        path: 'supervisors-configuration',
        loadComponent: () =>
          import('./scanning-configuration/supervisor-table/supervisor-table.component').then((m) => m.SupervisorTableComponent), data: { key: 'Supervisors', pageType: 'Manage Supervisors' },
      },
      {
        path: 'supervisors/:create',
        loadComponent: () =>
          import('./scanning-configuration/supervisors/supervisors.component').then((m) => m.SupervisorsComponent), data: { key: 'Supervisors', pageType: 'Manage Supervisors' },
      },
      {
        path: 'devices-configuration',
        loadComponent: () =>
          import('./scanning-configuration/devices/devices.component').then((m) => m.DevicesComponent), data: { key: 'Devices', pageType: 'Manage Devices' },
      },
      {
        path: 'devices-configuration/:id',
        loadComponent: () =>
          import('./scanning-configuration/device-details/device-details.component').then((m) => m.DeviceDetailsComponent)
      },
      {
        path: 'page-builder',
        loadComponent: () =>
          import('./page-builder/page-builder.component').then((m) => m.PageBuilderComponent), data: { key: 'Landing Page Builder', pageType: 'Configure your event landing page' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'promo-codes',
        loadComponent: () =>
          import('./discount-promocode/promo-code/promo-code.component').then((m) => m.PromoCodeComponent), data: { key: 'Discount & Promo Codes', pageType: 'Manage Discount & Promo Codes' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'supervisors/:id/operators',
        loadComponent: () =>
          import('./scanning-configuration/operators/operators.component').then((m) => m.OperatorsComponent), data: { key: 'operators', pageType: 'Manage Operators' },
        canActivate: [AuthGuard, OrganiserGuard],
      },

      {
        path: 'supervisors/:supervisorId/operators/:operatorId',
        loadComponent: () =>
          import('./scanning-configuration/operator-details/operator-details.component').then((m) => m.OperatorDetailsComponent), data: { key: 'operators', pageType: 'Manage Operator Details' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
       {
        path: 'devices-sessions/list',
        loadComponent: () =>
          import('./scanning-configuration/device-sessions/device-sessions.component').then((m) => m.DeviceSessionsComponent), data: { key: 'Device Sessions', pageType: 'Manage Device Sessions' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'registration/list',
        loadComponent: () =>
          import('./register/list/list.component').then((m) => m.ListComponent), data: { key: 'Buyer', pageType: 'Configure Buyer List' },
      },
      {
        path: 'registration/details/:id',
        loadComponent: () =>
          import('./register/details/details.component').then((m) => m.DetailsComponent), data: { key: 'Register-details', pageType: 'Configure Register Details Page' },
      },
      {
        path: 'buyer',
        loadComponent: () =>
          import('./buyer/buyer.component').then((m) => m.BuyerComponent), data: { key: 'Buyer', pageType: 'Configure Buyer landing page' },
      },
      {
        path: 'buyer-view',
        loadComponent: () =>
          import('./buyer/view/view.component').then((m) => m.ViewComponent), data: { key: 'Buyer', pageType: 'Configure Buyer landing page' },
      },
      {
        path: 'transactions/:id/details',
        loadComponent: () =>
          import('./transactions/transactions-details/transactions-details.component').then((m) => m.TransactionsDetailsComponent),
      },
      {
        path: 'event/publish/:id',
        loadComponent: () =>
          import('./event/publish-event/publish-event.component').then((m) => m.PublishEventComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'create-event/review/:id',
        loadComponent: () =>
          import('./event/event-review/event-review.component').then((m) => m.EventReviewComponent), data: { key: 'Events', pageType: 'Manage Leads & Prospects' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns',
        loadComponent: () =>
          import('./campaigns/campaigns.component').then((m) => m.CampaignsComponent), data: { key: 'Campaigns Configurations', pageType: 'Manage your Campaigns settings' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/email',
        loadComponent: () =>
          import('./campaigns/campaigns.component').then((m) => m.CampaignsComponent), data: { key: 'Email Configurations', pageType: 'Manage your Email Campaigns settings' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/whatsapp',
        loadComponent: () =>
          import('./campaigns/campaigns.component').then((m) => m.CampaignsComponent), data: { key: 'Whatsapp Configurations', pageType: 'Manage your Whatsapp settings' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/whatsapp/templates',
        loadComponent: () =>
          import('./campaigns/whatsapp-template-list/whatsapp-template-list.component').then((m) => m.WhatsappTemplateListComponent), data: { key: 'Whatsapp Templates', pageType: 'Manage your WhatsApp templates' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/whatsapp/templates/create',
        loadComponent: () =>
          import('./campaigns/whatsapp-template-create/whatsapp-template-create.component').then((m) => m.WhatsappTemplateCreateComponent), data: { key: 'Create WhatsApp Template', pageType: 'Create reusable WhatsApp message templates' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/whatsapp/settings',
        loadComponent: () =>
          import('./campaigns/whatsapp-settings/whatsapp-settings.component').then((m) => m.WhatsappSettingsComponent), data: { key: 'Whatsapp Settings', pageType: 'Connect and manage your WhatsApp Business API configuration' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/email-campaign',
        loadComponent: () =>
          import('./campaigns/email-campaign/email-campaign.component').then((m) => m.EmailCampaignComponent), data: { key: 'Email Configurations', pageType: 'Manage your Email Campaigns settings' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/whatsapp-campaigns',
        loadComponent: () =>
          import('./campaigns/whatsapp-campaign/whatsapp-campaign.component').then((m) => m.WhatsappCampaignComponent), data: { key: 'Whatsapp Configurations', pageType: 'Manage your Whatsapp settings' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/whatsapp-campaigns/create',
        loadComponent: () =>
          import('./campaigns/whatsapp-campaign-create/whatsapp-campaign-create.component').then((m) => m.WhatsappCampaignCreateComponent), data: { key: 'Whatsapp Configurations', pageType: 'Create your Whatsapp campaign' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/whatsapp-campaigns/flow/:id',
        loadComponent: () =>
          import('./campaigns/whatsapp-campaign-flow/whatsapp-campaign-flow.component').then((m) => m.WhatsappCampaignFlowComponent), data: { key: 'Whatsapp Campaign Flow', pageType: 'Track and review campaign flow details' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'campaigns/table-campaign',
        loadComponent: () =>
          import('./campaigns/campaign-table/campaign-table.component').then((m) => m.CampaignTableComponent),
        canActivate: [AuthGuard, OrganiserGuard]
      },
      {
        path: 'campaigns/campaign-details/:id',
        loadComponent: () =>
          import('./campaigns/campaign-details/campaign-details.component').then((m) => m.CampaignDetailsComponent),
        canActivate: [AuthGuard, OrganiserGuard]
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./organiser-user/organiser-user.component').then((m) => m.OrganiserUserComponent), data: { key: 'Organisers Audience', pageType: 'Organiser Audience' },
        canActivate: [AuthGuard, OrganiserGuard]
      },

      {
        path: 'participants',
        loadComponent: () =>
          import('./participants/participants.component').then((m) => m.ParticipantsComponent), data: { key: 'Participants Audience', pageType: 'Participants Audience' },
        canActivate: [AuthGuard, OrganiserGuard]
      },

      {
        path: 'campaigns/domain-configuration',
        loadComponent: () =>
          import('./campaigns/domain-configuration/domain-configuration.component').then((m) => m.DomainConfigurationComponent),
        data: { key: 'Domain Configurations', pageType: 'Manage your domain settings' },
        canActivate: [AuthGuard, OrganiserGuard]
      },
      {
        path: 'campaigns/domain',
        loadComponent: () =>
          import('./campaigns/campaign-domains/campaign-domains.component').then((m) => m.CampaignDomainsComponent),
        data: { key: 'Domain Configurations', pageType: 'Manage your Domain settings' },
        canActivate: [AuthGuard, OrganiserGuard]
      },
      {
        path: 'campaigns/tags',
        loadComponent: () =>
          import('./campaigns/campaign-tags/campaign-tags.component').then((m) => m.CampaignTagsComponent),
        data: { key: 'Tags', pageType: 'Manage your Tags settings' },
        canActivate: [AuthGuard, OrganiserGuard]
      },
      {
        path: 'campaigns/segments',
        loadComponent: () =>
          import('./campaigns/campaign-segments/campaign-segments.component').then((m) => m.CampaignSegmentsComponent),
        data: { key: 'Segment', pageType: 'Manage your Segment settings' },
        canActivate: [AuthGuard, OrganiserGuard]
      },
      {
        path: 'categories-configuration',
        loadComponent: () =>
          import('./home-page/categeries/categeries.component').then((m) => m.CategeriesComponent),
        data: { key: 'Homepage Configurations', pageType: 'Manage your homepage settings' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'speakers/artists',
        loadComponent: () =>
          import('./home-page/artist/artist.component').then((m) => m.ArtistComponent),
        data: { key: 'Homepage Configurations', pageType: 'Manage your homepage settings' },
        canActivate: [AuthGuard, OrganiserGuard],
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./users/users.component').then((m) => m.UsersComponent), data: { key: 'Users', pageType: 'Manage User Accounts' },
        // canActivate: [AuthGuard,HAuthorizeGuard],
      },

    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class dashboardRoutingModule {
  static routes = admin;
}
